import React, { useState, useEffect, useRef } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import uuid from 'react-uuid';
import { Formik } from 'formik';
import AttachmentForm from './AttachmentForm';
import WarningNotiifcation from 'components/WarningNotification';
import { connect } from 'react-redux';
import { putFiles, updateMany } from 'services';
import { SetLoading } from "redux/actions/loadingActions";
import { get } from 'services';
import { SetUser } from "redux/actions/userActions";
import { SetHasAttachment } from "redux/actions/hasAttachmentDataActions";
import { SetIsRequiredModule } from "redux/actions/isRequiredModuleActions";
import { SetOperationSuccess  } from "redux/actions/operationSuccessActions";
import { useHistory } from "react-router";
import { useWindowSize } from "./windowSize";

let yup = require('yup');
const Swal = require('sweetalert2');

const AttachmentFormWrapper = ({data, user, SetLoading, SetUser, SetOperationSuccess, opeationSuccess, SetHasAttachment, SetIsRequiredModule, hasAttachmentDataReducer, hasPersonalDataReducer, hasVehicleDataReducer, hasFamilyStructureDataReducer, hasEducationDataReducer, hasKnowledgeDataReducer, hasExperienceDataReducer, hasReferenceDataReducer, hasJobInformationDataReducer}) => {
    const [attachmentForm, setAttachmentForm] = useState([]);
    const [exampleOptionsArray, setExampleOptionsArray] = useState([]);
    const [loadForm, setLoadForm] = useState(false);
    const [formContent, setFormContent] = useState({});
    const [formikSchema, setFormikSchema] = useState({});
    const [basicSchema, setBasicSchema] = useState({});
    const [canSaveAndFinish, setCanSaveAndFinish] = useState(false);
    const formRef = useRef();
    const history = useHistory();
    const [width, height] = useWindowSize();
    const [shortName, setShortName] = useState(false);

    useEffect(() => {
        if (width <= 1300) {
            setShortName(true)
        } else {
            setShortName(false)
        }
    }, [width])

    useEffect(() => {
        let esEmpleadoReducer = true;

        // if (user.esEmpleado) {
        //     esEmpleadoReducer = hasFamilyStructureDataReducer;
        // }

        if (hasPersonalDataReducer && hasEducationDataReducer && hasKnowledgeDataReducer && hasExperienceDataReducer && hasReferenceDataReducer && hasJobInformationDataReducer) {
            setCanSaveAndFinish(true);
        } else {
            setCanSaveAndFinish(false);
            SetIsRequiredModule(true);
        }
    }, [hasPersonalDataReducer, hasEducationDataReducer, hasKnowledgeDataReducer, hasExperienceDataReducer, hasReferenceDataReducer, hasJobInformationDataReducer])

    useEffect(() => {
        (async function mounted() {
            console.log("se actualizo 21/8/21")
            if (!user.persona.personaDocumentos || user.persona.personaDocumentos.length == 0) {
                const response = await get(`PersonaDocumento/GetByPersonaId/${user.persona.id}`)
                user.persona.personaDocumentos = response.data;
            }

            if (user.persona.personaDocumentos && user.persona.personaDocumentos.length > 0) {
                user.persona.personaDocumentos = user.persona.personaDocumentos.filter(x => x);
                let schema = {};
                let values = {};
                let documentos = [];
                user.persona.personaDocumentos.forEach(documento => {
                    const documentoId = documento.id;
                    schema = {
                        ...schema,
                        [`documentoId_${documentoId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                        [`file_${documentoId}_`]: yup.string().typeError("El campo es requido"),
                    };
                    values = {
                        ...values,
                        [`documentoId_${documentoId}`]: documento.tipoDocumentoIdUI,
                        [`file_${documentoId}_`]: new File([""], documento.documentoNombreUI),
                    };
                    documentos.push({
                        id: documentoId,
                        documentoId: documento.documentoId,
                        estado: documento.estado,
                        isNew: false,
                    })
                });

                setBasicSchema(() => {
                    return schema;
                });
                updateFormik(schema);
                setFormContent(() => {
                    return values
                });
                setAttachmentForm(() => {
                    return [
                        ...documentos
                    ];
                });
            }
            
            setLoadForm(true);
        })();
    }, [])

    useEffect(() => {
        if (loadForm) {
            if (user.persona.personaDocumentos && user.persona.personaDocumentos.length == 0 || user.persona.personaDocumentos.every(x => x.estado == 0)) {
                onAddAttachmentForm();
            }
        }
    }, [loadForm]) 

    const updateFormik = (schema) => setFormikSchema(() => {
        return yup.object(schema);
    });

    const onAddAttachmentForm = () => {
     
        const guid = uuid();
        const oldValues = formRef.current.values;

        const newSchema = {
            ...basicSchema,
            [`documentoId_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`file_${guid}_`]: yup.string().typeError("El campo es requido"),
        }

        setBasicSchema(() => {
            return newSchema;
        });

        setFormContent(() => {
            return {
                ...oldValues,
                [`documentoId_${guid}`]: '',
                [`file_${guid}_`]: ''
            }
        });

        setAttachmentForm(() => {
            return [
                ...attachmentForm,
                {
                    id: guid,
                    estado: 1,
                    isNew: true,
                }
            ];
        });
        
        updateFormik(newSchema);
    };

    const onRemoveVehicleForm = (identifier) => {
        let newSchema = basicSchema;
        const oldValues = formRef.current.values;
        const removedForm = attachmentForm.find(x => x.id === identifier);

        const schemaKeys = [
            `documentoId_${identifier}`, 
            `file_${identifier}_`
        ];

        schemaKeys.forEach(key => {
            delete newSchema[key]
            delete oldValues[key]
        });

        setBasicSchema(() => {
            return newSchema;
        });

        setFormContent(() => {
            return oldValues
        });
        
        updateFormik(newSchema);
        if (removedForm.isNew) {
            setAttachmentForm(() => {
                return [
                    ...attachmentForm.filter(x => x.id !== identifier)
                ]
            })
        } else {
            const index = attachmentForm.indexOf(removedForm);
            let updateattachmentForm = attachmentForm;
            removedForm.estado = 0;
            updateattachmentForm[index] = removedForm;
            setAttachmentForm(() => {
                return [
                    ...updateattachmentForm
                ]
            })
        }
      
    };

    const getDocumentId = async (documentoPersona) => {
        try
        {
            const response = await putFiles('PersonaDocumento/DocumentoPersonaFiles', documentoPersona);
            return response.data.id;
        }
        catch (error)
        {
            const errorMessage = error?.response?.data?.Message || error?.response?.data?.message;
            if (typeof errorMessage === 'string' && errorMessage.includes('InvalidOperationException')) {
                throw new Error('La operación no pudo completarse. Por favor, intente nuevamente.');
            }

            throw new Error(errorMessage || '¡Ha ocurrido un error al procesar su solicitud!');
        }
    }

    const onExit = () => {
        history.push({
            pathname: "/attachments",
            state: {
                updateUserData: true
            }
        });
    }

    const onFormSubmitted = async (form) => {
        let isInvalidObject = false;
        let documentTypes = [];

        for(const element of attachmentForm) {
            if (element.isNew && !form['file_'+ element.id +'_']) {
                Swal.fire({
                    icon: 'warning',
                    title: '¡Atención!',
                    text: '¡Hay campos sin archivos!'
                });
                return;
            }
        }

        try {
            SetLoading(true);
            let createdDocuments = [];
            let personasDocumento = [];

            for(const element of attachmentForm) {
                
                const documentoTipoId = Number((element.estado === 0)
                    ? (user.persona.personaDocumentos.find(x => x.id === element.id)?.tipoDocumentoIdUI)
                    : (form['documentoId_' + element.id]));
                
                const file = (element.estado === 0)
                    ? null
                    : form['file_'+ element.id +'_'];

                let documentoPersona = new FormData();
                documentoPersona.append('id', element.isNew ? null : element.documentoId)
                documentoPersona.append('file', file)
                documentoPersona.append('documentoTipoId', documentoTipoId)

                const documentoId = await getDocumentId(documentoPersona);
                
                if (element.estado == 1) {
                    const otrosId = 2;
                    // if (documentoTipoId != otrosId && documentTypes.some(x => x == documentoTipoId)) {
                    //     isInvalidObject = true;
                    // }
                }
                
                createdDocuments.push({
                    id: element.isNew ? null : element.id,
                    documentId: documentoId,
                    estado: element.estado
                });

                if (element.estado == 1) {
                    documentTypes.push(documentoTipoId);
                }
            }

            if (isInvalidObject) {
                Swal.fire({
                    icon: 'warning',
                    title: '¡Atención!',
                    html: "No puede agregar un mismo tipo de documento más de una vez",  
                });
                return;
            }

            for(const document of createdDocuments) {
                const personaDocumento = {
                    id: document.id,
                    documentoId: document.documentId,
                    personaId: user.persona.id,
                    estado: document.estado
                }
                personasDocumento.push(personaDocumento)
            }

            const response = await updateMany('PersonaDocumento', personasDocumento/*, reCAPTCHA*/);

            if (response && response.data && response.data.some(x => x.estado == 1)) {
                SetHasAttachment(true);
            } else {
                SetHasAttachment(false);
            }
            SetOperationSuccess(opeationSuccess + 1);
            SetIsRequiredModule(false);

            Swal.fire({
                icon: 'success',
                title: '¡Hemos registrado tus datos exitosamente!',
                html: "Cuando tengas alguna novedad, puedes ingresar y actualizarlo. <br/><br/> ¡Muchas Gracias!",  
            });


        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: '¡Error!',
                text: error?.message || '¡Ha ocurrido un error inesperado!',
            });
        } finally {
            SetLoading(false); 
        }
    };

    return (
        <Card>
            <Card.Body className={'p-40'}>
                {
                    loadForm &&
                    <div>
                        <Formik
                            innerRef={formRef}
                            validationSchema={formikSchema}
                            onSubmit={onFormSubmitted}
                            initialValues={formContent}
                            enableReinitialize={true}
                            validateOnChange={false}
                            validateOnBlur={false}
                        >
                            {({
                                handleSubmit,
                                handleChange,
                                handleBlur,
                                values,
                                touched,
                                isValid,
                                errors,
                                setFieldValue
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Form.Row>
                                        {/* <Form.Group as={Col} md="12">
                                            <Button onClick={onAddAttachmentForm}> Agregar </Button>
                                        </Form.Group> */}

                                        <Form.Group 
                                            as={Col} 
                                            md="12" 
                                            controlId="campos_obligatorios"
                                            className="mb-0"
                                            style={{fontSize: 18}}>
                                                <div>
                                                    <b> Campos obligatorios * </b>
                                                </div>
                                        </Form.Group>
                                        
                                        <Form.Group as={Col} md="12" className="mb-25">
                                            <span style={{fontSize: 18}}>  Aquí puedes adjuntar, copia de cédula, copia de título, certificados de estudios realizados, etc. (Los archivos deben ser menor de 4MB) </span>
                                        </Form.Group>
                                        
                                        {/* <Form.Group as={Col} md="12">
                                            <div className="alert alert-warning" role="alert">
                                                <ul style={{ marginBottom: 0, paddingLeft: 20}}>
                                                    <li> Aquí puedes adjuntar, copia de cédula, copia de título, certificados de estudios realizados, etc.(Los archivos deben ser menor de 4MB) </li>
                                                </ul>
                                            </div>
                                        </Form.Group> */}

                                        {
                                            (attachmentForm.length > 0 && attachmentForm.filter(x => x.estado === 1).length > 0) ?
                                            attachmentForm.filter(x => x.estado === 1).map((element) => {
                                                return <AttachmentForm 
                                                    key={element.id} 
                                                    handleChange={handleChange} 
                                                    errors={errors} 
                                                    touched={touched} 
                                                    values={values} 
                                                    element={element}
                                                    removeVehicleForm={onRemoveVehicleForm}
                                                    options={exampleOptionsArray}
                                                    setFieldValue={setFieldValue}
                                                    displayShortName={shortName} />
                                            })
                                            : 
                                            <Form.Group as={Col} md="12">
                                                <WarningNotiifcation message='No ha agregado formularios a la sección ' enphasis='Documentos adjuntos'/>
                                            </Form.Group>
                                        }

                                        <Form.Group className={'display-flex flex-end'} as={Col} md="12">
                                            <Button onClick={onAddAttachmentForm}> Agregar </Button>
                                        </Form.Group>
                                    </Form.Row>
                                    
                                    {
                                        !canSaveAndFinish &&
                                        <>

                                            <Form.Group className={'display-flex flex-end mb-0'} as={Col} md="12" style={{paddingRight: 0, fontSize: 18}}>
                                                <span>
                                                    Para finalizar la solicitud, debes completar lo siguientes módulos:
                                                </span>
                                            </Form.Group>

                                            {
                                                !hasPersonalDataReducer &&
                                                <Form.Group className={'display-flex flex-end mb-0'} as={Col} md="12" style={{paddingRight: 0, fontSize: 18}}>
                                                    <span>
                                                        <i style={{fontSize: 15}} class="fa fa-exclamation"></i> Datos personales 
                                                    </span>
                                                </Form.Group>
                                            }

                                            {/* {
                                                user.esEmpleado &&
                                                <>
                                                    {
                                                        !hasFamilyStructureDataReducer &&
                                                        <Form.Group className={'display-flex flex-end mb-0'} as={Col} md="12" style={{paddingRight: 0, fontSize: 18}}>
                                                            <span>
                                                                <b> <i style={{fontSize: 15}} class="fa fa-exclamation"></i> Estructura familiar </b> 
                                                            </span>
                                                        </Form.Group>
                                                    }
                                                </>
                                            } */}

                                            {
                                                !hasEducationDataReducer  &&
                                                <Form.Group className={'display-flex flex-end mb-0'} as={Col} md="12" style={{paddingRight: 0, fontSize: 18}}>
                                                    <span>
                                                        <i style={{fontSize: 15}} class="fa fa-exclamation"></i> Educación 
                                                    </span>
                                                </Form.Group>
                                            }

                                            {
                                                !hasKnowledgeDataReducer  &&
                                                <Form.Group className={'display-flex flex-end mb-0'} as={Col} md="12" style={{paddingRight: 0, fontSize: 18}}>
                                                    <span>
                                                       <i style={{fontSize: 15}} class="fa fa-exclamation"></i> Conocimientos y habilidades
                                                    </span>
                                                </Form.Group>
                                            }

                                            {
                                                !hasExperienceDataReducer  &&
                                                <Form.Group className={'display-flex flex-end mb-0'} as={Col} md="12" style={{paddingRight: 0, fontSize: 18}}>
                                                    <span>
                                                        <i style={{fontSize: 15}} class="fa fa-exclamation"></i> Experiencias  
                                                    </span>
                                                </Form.Group>
                                            }

                                            {
                                                !hasReferenceDataReducer  &&
                                                <Form.Group className={'display-flex flex-end mb-0'} as={Col} md="12" style={{paddingRight: 0, fontSize: 18}}>
                                                    <span>
                                                        <i style={{fontSize: 15}} class="fa fa-exclamation"></i> Referencias
                                                    </span>
                                                </Form.Group>
                                            }

                                            {
                                                !hasJobInformationDataReducer  &&
                                                <Form.Group className={'display-flex flex-end mb-0'} as={Col} md="12" style={{paddingRight: 0, fontSize: 18}}>
                                                    <span>
                                                        <i style={{fontSize: 15}} class="fa fa-exclamation"></i> Información del empleo solicitado
                                                    </span>
                                                </Form.Group>
                                            }

                                            <br/>
                                        </>
                                    }

                                    {
                                        attachmentForm.length > 0 && 
                                        <Form.Group className={'display-flex space-between padding-right-0'} as={Col} md="12">
                                            {
                                                hasAttachmentDataReducer 
                                                ? <Button size="medium" variant="light" onClick={onExit}> <b> Cancelar edición </b> </Button>
                                                : <div> </div>
                                            }
                                            {
                                                canSaveAndFinish 
                                                ? <Button  size="medium" type="submit">Guardar y finalizar</Button>
                                                : <Button disabled={true} size="medium">Guardar y finalizar</Button>
                                            }
                                        </Form.Group>
                                    }
                                    
                                    {
                                        attachmentForm.length > 0 && 
                                        <Form.Group className={'display-flex flex-end'} as={Col} md="12">
                                            <div style={{fontSize: 18}}>
                                                Al enviar este formulario declaro que las informaciones suministradas en esta solicitud, son verídicas. Estoy consciente de las decisiones legales o penales que puedan presentarse, en caso de haber omitido la verdad.
                                            </div>
                                        </Form.Group>
                                    }

                                </Form>
                                )}
                        </Formik>
                    </div>
                }
            </Card.Body>
        </Card>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        opeationSuccess: state.opeationSuccess,
        hasAttachmentDataReducer: state.hasAttachmentDataReducer,
        hasPersonalDataReducer: state.hasPersonalDataReducer, //
        hasVehicleDataReducer: state.hasVehicleDataReducer, // --
        hasFamilyStructureDataReducer: state.hasFamilyStructureDataReducer, // --
        hasEducationDataReducer: state.hasEducationDataReducer, //
        hasKnowledgeDataReducer: state.hasKnowledgeDataReducer, //
        hasExperienceDataReducer: state.hasExperienceDataReducer, // 
        hasReferenceDataReducer: state.hasReferenceDataReducer, //
        hasJobInformationDataReducer: state.hasJobInformationDataReducer //
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetUser: (user) => dispatch(SetUser(user)),
        SetLoading: (value) => dispatch(SetLoading(value)),
        SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
        SetHasAttachment: (value) => dispatch(SetHasAttachment(value)),
        SetIsRequiredModule: (value) => dispatch(SetIsRequiredModule(value)),
    }
}


export default connect(mapStateToProps,mapDispatchToProps)(AttachmentFormWrapper);